module.exports = __webpack_public_path__ + "img/AI.6934322c.png";